import * as React from 'react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateUtils } from '@shared/utils/DateUtils';
import { ReactUtils } from '@shared/ui-react/ReactUtils';


interface IProps {
    value: number;
    onChange?: (timestamp: number) => void;
    mobile?: boolean;
    inputName?: string; // when used inside form, <input name=" ? ">
    placeholder?: string; // when used inside form, <input name=" ? ">

    showTimeSelect?: boolean;
    disabled?: boolean;
    clearable?: boolean;

    selectsStart?: boolean;
    selectsEnd?: boolean;
    startDate?: number;
    endDate?: number;
    minDate?: number;
    maxDate?: number;
}

export class DateTimePicker extends React.Component<IProps> {
    static defaultProps: IProps = {
        value: DateUtils.TODAY_START,
        onChange: () => console.log('DateTimePicker.onChange() not implemented'),
        mobile: false,
        showTimeSelect: false,
        selectsStart: false,
        selectsEnd: false,
        disabled: false,
        clearable: false
    };

    datepickerDefaultProps = {
        allowSameDay: true,
        closeOnSelect: true,
        autoFocus: false,
        showYearDropdown: true,
        showMonthDropdown: true,
        showWeekNumbers: true,
        timeIntervals: 15,
        timeFormat: 'p',
        dateFormat: this.props.showTimeSelect ? 'Pp' : 'P',
        withPortal: this.props.mobile,
        customInput: this.props.mobile ? <MobileInput/> : null,
        popperModifiers: {
            preventOverflow: {
                enabled: true,
                escapeWithReference: false,
                boundariesElement: 'viewport'
            }
        },
        isClearable: this.props.clearable
    };

    dayStart = new Date();
    dayEnd = new Date();

    constructor(props: IProps) {
        super(props);
        this.dayStart.setHours(0, 0, 0, 0);
        this.dayEnd.setHours(23, 59, 59, 999);
    }

    render() {
        const locale = DateUtils.getCurrentLocale();

        return (
            <>
                <DatePicker
                    {...this.datepickerDefaultProps}
                    locale={locale}
                    popperContainer={ReactUtils.BODY_PORTAL}
                    selected={this.props.value ? new Date(this.props.value) : null}
                    onChange={this.onChangeWrapper}
                    showTimeSelect={this.props.showTimeSelect}
                    disabled={this.props.disabled}
                    placeholderText={this.props.placeholder}
                    minDate={this.props.minDate}
                    minTime={this.props.showTimeSelect ? (this.props.minDate ?? this.dayStart) : null}
                    maxDate={this.props.maxDate}
                    maxTime={this.props.showTimeSelect ? (this.props.maxDate ?? this.dayEnd) : null}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    selectsStart={this.props.selectsStart}
                    selectsEnd={this.props.selectsEnd}
                />
                { this.props.inputName && <input type='hidden' name={this.props.inputName} value={this.props.value} /> }
          </>
        );
    }

    private onChangeWrapper = (value: Date): void => {
        this.props.onChange(+value);
    }
}


class MobileInput extends React.Component<any> {
    render() {
        return (
            <button onClick={this.props.onClick} style={{ minWidth: 125 }}>{this.props.value || ' - '}</button>
        );
    }
}
